import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { Calendar, ShipLogo } from '../../../assests/ExportImageIcon'
// GreenTick / StarWhite are only used inside the commented-out perk/rating sections below —
// /cruises/details doesn't return perks or ratings.
import '../../hotel/hotelListing/hotelResults.css'
import '../../hotel/hotel-details/hotelDetail.css'
import './cruiseDetail.css'
// ShipHighlight (Dinner & Bar / Shows / Onboard Activity tabs) is a fully static mock —
// /cruises/details doesn't return per-venue cards, only generic HTML blocks
// (ship.dining, ship.entertainment, etc.), rendered further below instead.
// import ShipHighlight from './shipHighlight/shipHighlight'
import CruiseSearchLoader from '../../../componants/cruiseSearchLoader/CruiseSearchLoader'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import { showToast } from '../../../componants/toast/toastService'
import { setCruiseDetails } from '../../../redux/cruiseSearch/cruiseSearchSlice'
import { formatMoney } from '../../../utils/formatMoney'

const formatSailingDate = (value) => {
    if (!value) return ''
    const date = new Date(value.replace(' ', 'T'))
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
}

const AccordionChevron = ({ open }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: '.2s ease' }}>
        <path d="M4 6l4 4 4-4" stroke="#026D4D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

// Overview description is clamped to 2 lines — "Read more" shows up whenever
// the text is long enough to likely be truncated by that clamp (a plain
// character-count check, not a scrollHeight/clientHeight DOM measurement —
// that measurement runs before web fonts finish loading and can under-report
// overflow, hiding the button even when the text is actually cut off).
// Clicking it expands the text in place (no popup) and turns into "Read less".
const OVERVIEW_READ_MORE_THRESHOLD = 160

const CruiseOverview = ({ text }) => {
    const [expanded, setExpanded] = useState(false)
    const overflowing = (text || '').length > OVERVIEW_READ_MORE_THRESHOLD

    return (
        <>
            <p className={`aboutProperty__desc cruiseOverview__desc ${expanded ? 'cruiseOverview__desc--expanded' : ''}`}>{text}</p>
            {overflowing && (
                <button type='button' className='cruiseOverview__readMore' onClick={() => setExpanded((v) => !v)}>
                    {expanded ? 'Read less' : 'Read more'}
                </button>
            )}
        </>
    )
}

// ship.dining / ship.entertainment / etc. come back as HTML blocks — labelled here for display.
const SHIP_SECTIONS = [
    { key: 'accommodation', label: 'Accommodation' },
    { key: 'dining', label: 'Dining' },
    { key: 'enrichment', label: 'Enrichment' },
    { key: 'entertainment', label: 'Entertainment' },
    { key: 'health_and_fitness', label: 'Health & Fitness' },
    { key: 'kids_and_teens', label: 'Kids & Teens' },
]

const CruiseDetail = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const selectedCruise = useSelector((state) => state.cruiseSearch.selectedCruise)
    const details = useSelector((state) => state.cruiseSearch.details)

    const [loading, setLoading] = useState(false)
    const [openDay, setOpenDay] = useState(1)
    const [openSection, setOpenSection] = useState('dining')

    useEffect(() => {
        if (!selectedCruise?.id || !selectedCruise?.session_id) return
        setLoading(true)
        service
            .post(endpoints.cruises.details, { id: selectedCruise.id, session_id: selectedCruise.session_id }, { timeout: 45000 })
            .then(({ data }) => {
                dispatch(setCruiseDetails(data.data))
            })
            .catch(() => {
                showToast('Unable to load cruise details right now.', 'error')
            })
            .finally(() => setLoading(false))
    }, [selectedCruise, dispatch])

    // "View Itinerary" on the results list navigates here with this flag —
    // once the itinerary section has actually rendered, jump to it. While
    // `loading` is true the component below renders a skeleton instead of the
    // real page, so this must wait for `loading` to clear too, not just for
    // `details` to arrive (they don't always settle in the same render).
    useEffect(() => {
        if (loading || !location.state?.scrollToItinerary || !details?.itinerary?.length) return
        const el = document.getElementById('itinerary-section')
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, [loading, location.state, details])

    if (!selectedCruise) {
        return (
            <section className='flightBookingDetails commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <p>No cruise selected. Please go back and search again.</p>
                    <button type='button' className='commonBtn' onClick={() => navigate('/cruise-list')}>Search Cruises</button>
                </div>
            </section>
        )
    }

    if (loading || !details) {
        return (
            <section className='allSearchArea commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <CruiseSearchLoader text='Loading cruise details...' />
                </div>
            </section>
        )
    }

    const ship = details.ship || {}

    return (
        <>
            <section className='allSearchArea commonTopPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='hotelAllDetail'>
                                <div className='hotelDetailGrid'>
                                    <div className='hotelDetailLeft'>
                                        <div className='hotelGallery'>
                                            {/* /cruises/details only returns a single ship_image, not a photo gallery */}
                                            <div className='hotelGallery__main'>
                                                <img src={ship.image || details.ship_image} alt={details.cruise_name} />
                                            </div>
                                            {/* <div className='hotelGallery__grid'>
                                                <img src={GALLERY_IMAGES[1]} alt={CRUISE_INFO.name} />
                                                <img src={GALLERY_IMAGES[2]} alt={CRUISE_INFO.name} />
                                                <img src={GALLERY_IMAGES[3]} alt={CRUISE_INFO.name} />
                                                <div className='hotelGallery__lastItem'>
                                                    <img src={GALLERY_IMAGES[4]} alt={CRUISE_INFO.name} />
                                                    <button type='button' className='hotelGallery__showAll'>Show all photos</button>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>

                                    <div className='hotelDetailRight'>
                                        <div className='hotelRoomCard'>
                                            <div className="bsSectionTitle">{details.cruise_name}</div>
                                            {/* Early check-in perk / partially-refundable tick aren't returned by /cruises/details */}
                                            {/* <ul className='hotelRoomCard__perks'>
                                                {STARTING_PRICE.perks.map((perk, index) => (
                                                    <li key={index}><img src={Watch} alt="" /> {perk}</li>
                                                ))}
                                                <li className='hotelRoomCard__perk--tick'><img src={GreenTick} alt="" /> {STARTING_PRICE.tickPerk}</li>
                                            </ul> */}

                                            <div className='hotelRoomCard__priceBlock'>
                                                <div className='hotelRoomCard__oldPriceRow'>
                                                    <span className='hotelRoomCard__perNight'>{details.trip_from_label || details.price_label || 'Starting from'}</span>
                                                </div>
                                                <div className='hotelRoomCard__price'>{formatMoney(details.from_price, details.currency)}</div>
                                                <div className='cruiseCard__shipName'>{details.price_label}</div>
                                            </div>

                                            {details.available_dates_count > 0 && (
                                                <div className='cruiseCard__shipName mb-2'>{details.available_dates_count} sailing date{details.available_dates_count > 1 ? 's' : ''} available</div>
                                            )}

                                            <button type='button' className='commonBtn w-100' onClick={() => navigate('/cruise-booking-detail')}>Continue</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='hotelInfoCard'>
                                <div className='hotelInfoCard__top'>
                                    <div className='cruiseDetail__nameRow'>
                                        {/* <div className='shipLogo'>
                                            <img src={ShipLogo} alt="" className='cruiseDetail__shipLogo' />
                                        </div> */}
                                        <div>
                                            <div className='hotelInfoCard__name'>{details.cruise_name}</div>
                                            <div className='cruiseCard__shipName'>{details.cruise_line} • {ship.name || details.ship_name}</div>
                                            <div className='cruiseCard__shipName'>
                                                {details.duration_label} • {formatSailingDate(details.departure_date)} • {details.departure_port_name}
                                                {details.return_port_name && details.return_port_name !== details.departure_port_name ? ` → ${details.return_port_name}` : ''}
                                            </div>
                                        </div>
                                    </div>
                                    {/* rating/reviewsText aren't returned by /cruises/details */}
                                    {/* <div className='hotelInfoCard__ratingBlock'>
                                        <span className='hotelCard__ratingBadge'>
                                            <img src={StarWhite} alt="" /> {CRUISE_INFO.rating}
                                        </span>
                                        <span className='hotelInfoCard__reviews'>{CRUISE_INFO.reviewsText}</span>
                                    </div> */}
                                </div>

                                <div className='cruiseStatsRow'>
                                    <div className='cruiseStatCard'>
                                        <div className='cruiseStatCard__value commonGredientText'>{details.duration_label}</div>
                                        <div className='cruiseStatCard__label'>Duration</div>
                                    </div>
                                    <div className='cruiseStatCard'>
                                        <div className='cruiseStatCard__value commonGredientText'>{ship.max_occupancy ?? '-'}</div>
                                        <div className='cruiseStatCard__label'>Passengers</div>
                                    </div>
                                    <div className='cruiseStatCard'>
                                        <div className='cruiseStatCard__value commonGredientText'>{details.ports?.length ?? '-'}</div>
                                        <div className='cruiseStatCard__label'>Ports</div>
                                    </div>
                                    {/* <div className='cruiseStatCard'>
                                        <div className='cruiseStatCard__value commonGredientText'>{stat.value}</div>
                                        <div className='cruiseStatCard__label'>{stat.label}</div>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                        {ship.description && (
                            <div className='col-md-12'>
                                <div className='amenities__head'>
                                    <div className='bsSectionTitle'>Overview</div>
                                </div>
                                <div className='aboutProperty bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <CruiseOverview text={ship.description} />
                                </div>
                            </div>
                        )}

                        {/* Amenities row (Multi-Cuisine Restaurant/Coffee Shop/Bar & Lounge) isn't returned by /cruises/details */}
                        {/* <div className='col-md-12'>
                            <div className='amenities__head'>
                                <div className='bsSectionTitle'>Amenities</div>
                                <span className='tripSecureViewAll'>View All</span>
                            </div>
                            <div className='amenities'>
                                <div className='amenities__row bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    {AMENITIES.map((item, index) => (
                                        <div className='amenities__item' key={index}>
                                            <img src={item.icon} alt="" />
                                            <span>{item.label}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div> */}

                        {details.sailing_prices?.length > 0 && (
                            <div className='col-md-12'>
                                <div className='bsSectionTitle'>Cabin Prices</div>
                                <div className='bsBox'>
                                    {details.sailing_prices.map((price, index) => (
                                        <React.Fragment key={index}>
                                            <div className='bsFareRow'>
                                                <span>{price.cabin_category}</span>
                                                <span>{formatMoney(price.adult_fare, price.currency_code)} <span style={{ fontWeight: 400 }}>+ {formatMoney(price.tax, price.currency_code)} tax</span></span>
                                            </div>
                                            {index < details.sailing_prices.length - 1 && <div className='bsFareDivider' />}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        )}

                        {details.itinerary?.length > 0 && (
                            <div className='col-md-12' id='itinerary-section'>
                                <div className='bsSectionTitle'>Itinerary</div>
                                {/* <div className='bgWhite commonBorder borderRadius20 paddingCommon20 mb-3'>
                                {details.ports_summary && <p className='aboutProperty__desc mb-3'>{details.ports_summary}</p>}
                                </div> */}
                                <div className='itineraryCard bgWhite commonBorder borderRadius20'>
                                    <div className='itineraryCard__grid'>
                                        <div className='itineraryCard__image'>
                                            <img src={ship.image || details.ship_image} alt="Itinerary" />
                                        </div>
                                        <div className='itineraryCard__days'>
                                            {details.itinerary.map((dayItem) => {
                                                const open = openDay === dayItem.day
                                                return (
                                                    <div
                                                        className='itineraryDay'
                                                        key={dayItem.day}
                                                        onClick={() => setOpenDay(open ? null : dayItem.day)}
                                                    >
                                                        <div className='itineraryDay__head'>
                                                            <div className='itineraryDay__dayCol'>
                                                                <span>Day</span>
                                                                <span>{dayItem.day}</span>
                                                            </div>
                                                            <div className='itineraryDay__content'>
                                                                <div className='itineraryDay__title'>{dayItem.port_name}</div>
                                                                <div className='itineraryDay__tag'>{dayItem.day_label}</div>
                                                                {open && (
                                                                    <>
                                                                        <div className='itineraryDay__time'><img src={Calendar} alt="" /> Arrival {dayItem.arrival_time} • Departure {dayItem.departure_time}</div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <AccordionChevron open={open} />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Ship Highlights (Dinner & Bar / Shows / Onboard Activity tabs) — see import note above */}
                        {/* <ShipHighlight /> */}

                        {SHIP_SECTIONS.some((section) => ship[section.key]) && (
                            <div className='col-md-12'>
                                <div className='bsSectionTitle'>Ship Details</div>
                                <div className='bgWhite commonBorder borderRadius20 shipDeailmain'>
                                    {SHIP_SECTIONS.filter((section) => ship[section.key]).map((section) => {
                                        const open = openSection === section.key
                                        return (
                                            <div className='itineraryDay' key={section.key} onClick={() => setOpenSection(open ? null : section.key)}>
                                                <div className='itineraryDay__head'>
                                                    <div className='itineraryDay__content'>
                                                        <div className='itineraryDay__title'>{section.label}</div>
                                                        {open && (
                                                            <div className='aboutProperty__desc mt-2' dangerouslySetInnerHTML={{ __html: ship[section.key] }} />
                                                        )}
                                                    </div>
                                                    <AccordionChevron open={open} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}

                        {ship.cabin_types?.length > 0 && (
                            <div className='col-md-12'>
                                <div className='roomType'>
                                    <div className='bsSectionTitle'>Select Room</div>
                                    {/* Cabin cards (photos/bullets/pricing) below aren't returned by /cruises/details —
                                        ship.cabin_types only gives a type name, colour and optional image. */}
                                    <div className='cruiseDetail__cabinTypeRow'>
                                        {ship.cabin_types.map((cabin, index) => (
                                            <div className='bgWhite commonBorder borderRadius20 cruiseDetail__cabinTypeCard hoverLift' key={index}>
                                                
                                                <div className='cruiseDetail__cabinTypeBody' onClick={() => navigate('/cruise-booking-detail')} style={{ cursor: 'pointer' }}>
                                                    <div className='cabinCard__title'>
                                                        {cabin.image && <span className='cruiseDetail__cabinTypeDot' style={{ background: cabin.color || '#D1D5DB' }} />}
                                                        {cabin.cabin_type}
                                                    </div>
                                                    {/* <button type='button' className='commonBtn cruiseDetail__cabinTypeBtn' onClick={() => navigate('/cruise-booking-detail')}>Continue</button> */}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {/* <div className='roomTypeList'>
                                        {CABIN_TYPES.map((cabin, index) => (
                                            <div className='cabinCard bgWhite commonBorder borderRadius20' key={index}>
                                                <div className='cabinCard__image roomTypeCard__gallery'>
                                                    <Swiper modules={[Pagination]} pagination={{ clickable: true }} loop>
                                                        {cabin.images.map((img, imgIndex) => (
                                                            <SwiperSlide key={imgIndex}>
                                                                <img src={img} alt={cabin.title} />
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                    <span className='roomTypeCard__photoCount'>{cabin.photoCount}</span>
                                                </div>
                                                <div className='cabinCard__info'>
                                                    <div className='cabinCard__title'>{cabin.title}</div>
                                                    <p className='cabinCard__desc'>{cabin.desc}</p>
                                                    <ul className='bsInfoList'>
                                                        {cabin.bullets.map((bullet, bulletIndex) => (
                                                            <li key={bulletIndex}>{bullet}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <div className='cabinCard__price'>
                                                    <span className='roomTypePrice__old'>{cabin.oldPrice}</span>
                                                    <span className='roomTypePrice__current'>{cabin.price}<span className='cabinCard__priceNote'>{cabin.perPerson}</span></span>
                                                    <span className='cabinCard__taxesNote'>{cabin.taxesNote}</span>
                                                    <button type='button' className='commonBtn cabinCard__btn'>Reserve 1 Room</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div> */}
                                </div>
                            </div>
                        )}

                        {/* What's Included / Reviews & Ratings / All Amenities / Property Rules aren't returned by /cruises/details */}
                        {/* <div className='col-md-12'>
                            <div className='bsSectionTitle'>What's Included</div>
                            <div className='featureGrid'>
                                <div className='aboutProperty bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <p className='aboutProperty__desc'>{FEATURE_TEXT}</p>
                                    <p className='aboutProperty__desc'>{FEATURE_TEXT}</p>
                                </div>
                                <div className='bgWhite commonBorder borderRadius20'>
                                    {FEATURE_HIGHLIGHTS.map((item, index) => (
                                        <div className='securityMenuItem' key={index}>
                                            <span className='hotelInfoCard__locationIcon'>
                                                <img src={item.icon} alt="" />
                                            </span>
                                            <div className='securityMenuItem__info'>
                                                <div className='securityMenuItem__title'>{item.label}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='reviewPart'>
                                <div className='reviewPart__head'>
                                    <div className='bsSectionTitle'>Reviews & Ratings</div>
                                    <span className='tripSecureViewAll'>View All</span>
                                </div>

                                <div className='reviewPart__grid'>
                                    <div className='reviewSummary bgWhite commonBorder borderRadius20'>
                                        <div className='reviewSummary__scoreRow'>
                                            <div className='reviewSummary__score'>{REVIEW_SUMMARY.average}</div>
                                            <div>
                                                <div className='reviewSummary__stars'>
                                                    {Array.from({ length: 5 }).map((_, index) => <GoldStar key={index} />)}
                                                </div>
                                                <div className='reviewSummary__count'>{REVIEW_SUMMARY.totalReviews.toLocaleString('en-IN')} reviews</div>
                                            </div>
                                        </div>

                                        <div className='reviewSummary__bars'>
                                            {REVIEW_SUMMARY.breakdown.map((row) => (
                                                <div className='reviewBarRow' key={row.star}>
                                                    <span className={`reviewBarRow__label reviewBarRow__label--${row.color}`}>{row.star}★</span>
                                                    <span className='reviewBarRow__track'>
                                                        <span className={`reviewBarRow__fill reviewBarRow__fill--${row.color}`} style={{ width: `${row.percent}%` }} />
                                                    </span>
                                                    <span className='reviewBarRow__count'>{row.count}</span>
                                                </div>
                                            ))}
                                        </div>

                                        <div className='reviewSummary__divider' />

                                        <div className='reviewSummary__categories'>
                                            {REVIEW_SUMMARY.categories.map((category) => (
                                                <div className='reviewCategory' key={category.label}>
                                                    <span className='reviewCategory__label'>{category.label}</span>
                                                    <span className='reviewCategory__value'>{category.value}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className='reviewList'>
                                        {REVIEWS.map((review, index) => (
                                            <div className='reviewCard bgWhite commonBorder borderRadius20' key={index}>
                                                <div className='reviewCard__head'>
                                                    <span className='reviewCard__avatar'>
                                                        <img src={User} alt="" />
                                                    </span>
                                                    <div>
                                                        <div className='reviewCard__name'>{review.name}</div>
                                                        <div className='reviewCard__meta'>
                                                            <span className='reviewCard__stars'>
                                                                {Array.from({ length: 5 }).map((_, index) => <GoldStar key={index} filled={index < review.rating} />)}
                                                            </span>
                                                            <span className='reviewCard__time'>{review.time}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className='reviewCard__text'>{review.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='bsSectionTitle'>Amenities</div>

                            <div className='allAmeneties bgWhite commonBorder borderRadius20 paddingCommon20'>
                                <div className='allAmeneties__grid'>
                                    {ALL_AMENITIES.map((column, colIndex) => (
                                        <div className='allAmeneties__column' key={colIndex}>
                                            {column.map((group) => (
                                                <div className='amenityGroup' key={group.title}>
                                                    <div className='amenityGroup__title'>{group.title}</div>
                                                    <ul className='bsInfoList'>
                                                        {group.items.map((item) => (
                                                            <li key={item}>{item}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <div className='propertyRules'>
                                <div className='bsSectionTitle'>Property Rules & Information</div>
                                <div className='propertyRules__card bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <div className='propertyRules__highlight'>
                                        <div className='propertyRules__highlightTitle'>
                                            <img src={Heart} alt="" /> {COUPLE_RULE.title}
                                        </div>
                                        <div className='propertyRules__highlightDesc'>{COUPLE_RULE.desc}</div>
                                    </div>

                                    <ul className='bsInfoList propertyRules__list'>
                                        {PROPERTY_RULES.map((rule, index) => (
                                            <li key={index}>{rule}</li>
                                        ))}
                                    </ul>

                                    <button type='button' className='aboutProperty__readMore'>View More</button>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
            </section>
        </>
    )
}

export default CruiseDetail
